"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var images = function images(messages) {
  return messages.map(function (message, i) {
    return message.src && _react2.default.createElement("img", { draggable: "false", role: "presentation", key: i, src: message.src, width: '1px', height: '1px' });
  });
};

var ImageLoader = function ImageLoader(_ref) {
  var messages = _ref.messages,
      styles = _ref.styles;


  return _react2.default.createElement(
    "div",
    { className: "imageLoaderContainer" },
    images(messages)
  );
};

ImageLoader.propTypes = {
  messages: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    src: _react.PropTypes.string
  })).isRequired,
  styles: _react.PropTypes.object
};

exports.default = ImageLoader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Chat/ImageLoader.js
// module id = 789
// module chunks = 0